import React, { useState } from 'react';
import InfoTooltip from './InfoTooltip';

// ─── BARTHEL INDEX (10 items, score 0-20) ───
const BARTHEL_ITEMS = [
  {
    id: 'tranzit_intestinal',
    name: 'Tranzit intestinal',
    icon: '🔄',
    options: [
      { value: 0, label: 'Incontinență (sau necesită clisme)' },
      { value: 1, label: 'Accident ocazional (un eveniment / săptămână)' },
      { value: 2, label: 'Continent' },
    ]
  },
  {
    id: 'vezica_urinara',
    name: 'Vezica urinară',
    icon: '💧',
    options: [
      { value: 0, label: 'Incontinență, sau cateterizat cu inabilitate de manipulare' },
      { value: 1, label: 'Accident ocazional (max. unul per 24 ore)' },
      { value: 2, label: 'Continent (pentru mai mult de 7 zile)' },
    ]
  },
  {
    id: 'ingrijire_personala',
    name: 'Îngrijire personală',
    icon: '🪥',
    options: [
      { value: 0, label: 'Necesită ajutor pentru îngrijirea personală' },
      { value: 1, label: 'Autonomă / autonom (față, păr, dinți, bărbierit)' },
    ]
  },
  {
    id: 'utilizare_toaleta',
    name: 'Utilizarea toaletei',
    icon: '🚽',
    options: [
      { value: 0, label: 'Dependent' },
      { value: 1, label: 'Necesită ajutor, dar poate face câte ceva singur' },
      { value: 2, label: 'Independent (așezare, ridicare, îmbrăcare, ștergere)' },
    ]
  },
  {
    id: 'alimentare',
    name: 'Alimentare',
    icon: '🍽️',
    options: [
      { value: 0, label: 'Incapabil' },
      { value: 1, label: 'Necesită ajutor la tăiat, întins unt, etc.' },
      { value: 2, label: 'Independent (alimentele pregătite la îndemână)' },
    ]
  },
  {
    id: 'transfer',
    name: 'Transfer (pat – scaun)',
    icon: '🛏️',
    options: [
      { value: 0, label: 'Incapabil – fără echilibru în poziția șezut' },
      { value: 1, label: 'Ajutor semnificativ (1-2 persoane, suport fizic)' },
      { value: 2, label: 'Ajutor minim (încurajare verbală sau suport fizic)' },
      { value: 3, label: 'Independent' },
    ]
  },
  {
    id: 'mobilitate',
    name: 'Mobilitate',
    icon: '🚶',
    options: [
      { value: 0, label: 'Imobil' },
      { value: 1, label: 'Independent în scaunul cu rotile (inclusiv colțuri)' },
      { value: 2, label: 'Pășește cu ajutorul unei persoane' },
      { value: 3, label: 'Independent (se permite folosirea bastonului)' },
    ]
  },
  {
    id: 'imbracaminte',
    name: 'Îmbrăcare',
    icon: '👔',
    options: [
      { value: 0, label: 'Dependent' },
      { value: 1, label: 'Necesită ajutor, dar poate pe jumătate singur' },
      { value: 2, label: 'Independent (nasturi, fermoar, șireturi)' },
    ]
  },
  {
    id: 'deplasare_scari',
    name: 'Deplasare pe scări',
    icon: '🪜',
    options: [
      { value: 0, label: 'Incapabil' },
      { value: 1, label: 'Necesită ajutor (verbal, sprijin fizic)' },
      { value: 2, label: 'Independent la urcare și coborâre' },
    ]
  },
  {
    id: 'imbaiere',
    name: 'Îmbăiere',
    icon: '🛁',
    options: [
      { value: 0, label: 'Dependent' },
      { value: 1, label: 'Independent (sau în duș)' },
    ]
  },
];

// ─── ADL – Activitățile de bază ale vieții zilnice (6 items) ───
const ADL_ITEMS = [
  {
    id: 'adl_baie',
    name: 'Igiena corporală (baie)',
    icon: '🚿',
    options: [
      { value: 0, label: 'Dependent – necesită ajutor complet' },
      { value: 1, label: 'Independent – se spală singur' },
    ]
  },
  {
    id: 'adl_imbracaminte',
    name: 'Îmbrăcare',
    icon: '👕',
    options: [
      { value: 0, label: 'Dependent – necesită ajutor complet' },
      { value: 1, label: 'Parțial – necesită ajutor doar pentru anumite piese' },
      { value: 2, label: 'Independent – se îmbracă singur' },
    ]
  },
  {
    id: 'adl_toaleta',
    name: 'Utilizarea toaletei',
    icon: '🚽',
    options: [
      { value: 0, label: 'Dependent – necesită ajutor complet' },
      { value: 1, label: 'Parțial – necesită supraveghere sau ajutor' },
      { value: 2, label: 'Independent – merge singur la toaletă' },
    ]
  },
  {
    id: 'adl_transfer',
    name: 'Transfer / Mobilitate',
    icon: '🔄',
    options: [
      { value: 0, label: 'Dependent – nu se poate deplasa' },
      { value: 1, label: 'Parțial – necesită sprijin' },
      { value: 2, label: 'Independent – se deplasează singur' },
    ]
  },
  {
    id: 'adl_continenta',
    name: 'Continență',
    icon: '✅',
    options: [
      { value: 0, label: 'Incontinent' },
      { value: 1, label: 'Accidente ocazionale' },
      { value: 2, label: 'Continent – control total' },
    ]
  },
  {
    id: 'adl_alimentare',
    name: 'Alimentare',
    icon: '🍴',
    options: [
      { value: 0, label: 'Dependent – necesită hrănire' },
      { value: 1, label: 'Parțial – necesită ajutor la tăiat, etc.' },
      { value: 2, label: 'Independent – mănâncă singur' },
    ]
  },
];

// ─── IADL – Activități instrumentale ale vieții zilnice (8 items) ───
const IADL_ITEMS = [
  {
    id: 'iadl_telefon',
    name: 'Utilizarea telefonului',
    icon: '📞',
    options: [
      { value: 0, label: 'Nu poate folosi telefonul deloc' },
      { value: 1, label: 'Poate răspunde dar nu poate forma numere' },
      { value: 2, label: 'Folosește telefonul independent' },
    ]
  },
  {
    id: 'iadl_cumparaturi',
    name: 'Cumpărături',
    icon: '🛒',
    options: [
      { value: 0, label: 'Incapabil de cumpărături' },
      { value: 1, label: 'Necesită însoțitor la cumpărături' },
      { value: 2, label: 'Face cumpărături independent' },
    ]
  },
  {
    id: 'iadl_gatit',
    name: 'Pregătirea mâncării',
    icon: '🍳',
    options: [
      { value: 0, label: 'Nu poate pregăti masa' },
      { value: 1, label: 'Poate încălzi / pregăti mese simple' },
      { value: 2, label: 'Gătește independent mese complete' },
    ]
  },
  {
    id: 'iadl_menaj',
    name: 'Menaj (întreținere locuință)',
    icon: '🏠',
    options: [
      { value: 0, label: 'Nu poate întreține locuința' },
      { value: 1, label: 'Ajutor pentru sarcini grele' },
      { value: 2, label: 'Întreține locuința independent' },
    ]
  },
  {
    id: 'iadl_rufe',
    name: 'Spălat rufe',
    icon: '🧺',
    options: [
      { value: 0, label: 'Nu poate spăla rufe deloc' },
      { value: 1, label: 'Spală doar obiecte mici' },
      { value: 2, label: 'Își spală toate rufele independent' },
    ]
  },
  {
    id: 'iadl_transport',
    name: 'Transport',
    icon: '🚌',
    options: [
      { value: 0, label: 'Nu se poate deplasa singur' },
      { value: 1, label: 'Se deplasează cu însoțitor' },
      { value: 2, label: 'Folosește transportul public independent' },
    ]
  },
  {
    id: 'iadl_medicamente',
    name: 'Administrarea medicamentelor',
    icon: '💊',
    options: [
      { value: 0, label: 'Nu își poate administra medicamentele' },
      { value: 1, label: 'Ia medicamentele dacă sunt pregătite în avans' },
      { value: 2, label: 'Își administrează medicamentele corect, independent' },
    ]
  },
  {
    id: 'iadl_finante',
    name: 'Gestionarea finanțelor',
    icon: '💰',
    options: [
      { value: 0, label: 'Incapabil de gestionare financiară' },
      { value: 1, label: 'Gestionează cheltuieli zilnice, necesită ajutor la bănci' },
      { value: 2, label: 'Gestionează finanțele complet independent' },
    ]
  },
];

function getBarhelInterpretation(score) {
  if (score === 20) return { text: 'Independent', color: '#28a745', icon: '🟢' };
  if (score >= 15) return { text: 'Dependență ușoară', color: '#17a2b8', icon: '🔵' };
  if (score >= 10) return { text: 'Dependență moderată', color: '#e67e22', icon: '🟡' };
  if (score >= 5) return { text: 'Dependență severă', color: '#dc3545', icon: '🟠' };
  return { text: 'Dependență totală', color: '#c0392b', icon: '🔴' };
}

function getADLInterpretation(score, maxScore) {
  const pct = (score / maxScore) * 100;
  if (pct >= 90) return { text: 'Independent', color: '#28a745', icon: '🟢' };
  if (pct >= 60) return { text: 'Dependență ușoară/moderată', color: '#e67e22', icon: '🟡' };
  if (pct >= 30) return { text: 'Dependență severă', color: '#dc3545', icon: '🟠' };
  return { text: 'Dependență totală', color: '#c0392b', icon: '🔴' };
}

function ScaleSection({ title, icon, items, scores, onScoreChange, interpretation, maxScore }) {
  const totalScore = Object.values(scores).reduce((a, b) => a + b, 0);
  const interp = interpretation(totalScore, maxScore);
  const answered = Object.keys(scores).length;

  return (
    <div style={{ marginBottom: '24px' }}>
      <div style={{ 
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '14px 18px', 
        background: 'linear-gradient(135deg, #e8eaf6, #e3f2fd)',
        borderRadius: '12px 12px 0 0',
        borderBottom: '2px solid #90caf9'
      }}>
        <h4 style={{ margin: 0, color: '#1565c0', fontSize: '15px' }}>
          {icon} {title}
        </h4>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontSize: '13px', color: '#666' }}>{answered}/{items.length} completate</span>
          <span style={{ 
            padding: '4px 12px', borderRadius: '16px', fontSize: '13px', fontWeight: 700,
            color: 'white', background: interp.color
          }}>
            {interp.icon} {totalScore}/{maxScore} – {interp.text}
          </span>
        </div>
      </div>

      <div style={{ border: '1px solid #e0e6ed', borderTop: 'none', borderRadius: '0 0 12px 12px', overflow: 'hidden' }}>
        {items.map((item, idx) => {
          const selectedValue = scores[item.id];
          const isAnswered = selectedValue !== undefined;

          return (
            <div key={item.id} style={{ 
              padding: '14px 18px',
              borderBottom: idx < items.length - 1 ? '1px solid #f0f0f0' : 'none',
              background: isAnswered ? '#fafffe' : 'white'
            }}>
              <div style={{ fontWeight: 600, fontSize: '14px', color: '#2c3e50', marginBottom: '8px' }}>
                {item.icon} {item.name}
                {isAnswered && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#28a745' }}>✓</span>}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', paddingLeft: '8px' }}>
                {item.options.map(opt => {
                  const isSelected = selectedValue === opt.value;
                  return (
                    <label key={opt.value} style={{
                      display: 'flex', alignItems: 'center', cursor: 'pointer',
                      padding: '8px 12px', borderRadius: '6px',
                      border: isSelected ? '2px solid #0056b3' : '2px solid transparent',
                      background: isSelected ? '#e8f0fe' : '#f8f9fa',
                      transition: 'all 0.15s ease',
                      fontSize: '13px'
                    }}>
                      <input 
                        type="radio" 
                        name={item.id}
                        checked={isSelected}
                        onChange={() => onScoreChange(item.id, opt.value)}
                        style={{ marginRight: '10px', accentColor: '#0056b3' }}
                      />
                      <span style={{ color: isSelected ? '#0056b3' : '#555', fontWeight: isSelected ? 600 : 400 }}>
                        {opt.label}
                      </span>
                      <span style={{ 
                        marginLeft: 'auto', fontSize: '11px', fontWeight: 700,
                        padding: '2px 8px', borderRadius: '10px',
                        background: opt.value === 0 ? '#ffebee' : opt.value >= (item.options.length - 1) ? '#e8f5e9' : '#fff8e1',
                        color: opt.value === 0 ? '#c62828' : opt.value >= (item.options.length - 1) ? '#2e7d32' : '#e65100',
                      }}>
                        {opt.value} pct
                      </span>
                    </label>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const EVAL_GROUPS = {
  1: {
    title: "GRUPUL 1: Deficit Biomecanic și Motor",
    desc: "Afectează autonomia prin scăderea forței musculare, coordonării sau amputații.",
    focus: [
      "Alimentația (ADL/Barthel): Are prehensiune (poate ține furculița/cana)? Poate duce alimentele la gură fără să le verse?",
      "Igienă și toaletă corporală (ADL/Barthel): Se poate spăla singur pe față/dinți? Are echilibru pentru duș?",
      "Îmbrăcarea (ADL/Barthel): Poate încheia nasturii, lega șireturile? Își poate trage hainele?",
      "Mersul și Transferul (ADL/Barthel): Se poate muta din pat în fotoliu? Se poate deplasa 50m (inclusiv baston/cadru)?",
      "Continența sfincteriană (ADL/Barthel): Prezintă incontinență urinară/fecală (ex. afecțiuni medulare)?"
    ],
    color: "#e8f4f8", borderColor: "#b3e0f2", icon: "🦾"
  },
  2: {
    title: "GRUPUL 2: Deficit Cognitiv și Comportamental",
    desc: "Deficiența nu este fizică (mușchii funcționează), ci decizională și de inițiere.",
    focus: [
      "Auto-determinare (ADL): Se spală/îmbracă doar dacă i se spune? Alege haine potrivite pentru anotimp?",
      "Medicamente și Bani (IADL): Recunoaște valoarea banilor? Respectă dozele tratamentului nesupravegheat?",
      "Gătitul și menajul (IADL): Prezintă un pericol dacă folosește aragazul sau cuțitele (risc de incendiu/rănire)?",
      "Transport / Telefon (IADL): Se poate orienta în spațiu? Știe să ceară ajutor dacă se rătăcește?"
    ],
    color: "#f4f0fa", borderColor: "#d1b3f2", icon: "🧠"
  },
  3: {
    title: "GRUPUL 3: Deficit de Efort (Hipoxie, Cașexie, Dispnee)",
    desc: "Pacientul are forță și intelect, dar inima/plămânii/metabolismul nu susțin efortul.",
    focus: [
      "Mersul / Scările (Barthel): Apare sufocarea (dispneea) la mersul prin casă? Poate urca un etaj fără lipsă de oxigen?",
      "Igienă și Îmbrăcat (ADL): Apare epuizarea severă (fatigabilitatea) la pieptănat sau spălat? Necesită pauze lungi?",
      "Gătit, Menaj, Cumpărături (IADL): Este incapabil să ducă greutăți mici (2kg) sau să stea în picioare 15 minute?"
    ],
    color: "#fcf0f0", borderColor: "#f2b3b3", icon: "🫁"
  },
  4: {
    title: "GRUPUL 4: Deficit Senzorial și de Comunicare",
    desc: "Limitarea provine din lipsa văzului, auzului sau comunicării vocale.",
    focus: [
      "Transport și orientare (IADL/Barthel): Se poate orienta spațial în interior/exterior? Necesită însoțitor permanent pe stradă?",
      "Prepararea hranei & Medicamente (IADL): Risc major de arsuri la gătit sau dozare incorectă a pastilelor pentru nevăzători.",
      "Utilizarea telefonului (IADL): Este comunicarea prin voce imposibilă (ex. surdo-cecitate, traheostomă)?"
    ],
    color: "#fff9e6", borderColor: "#ffe082", icon: "👁️"
  },
  5: {
    title: "GRUPUL 5: Bariere Fizice, Durere Severă sau Leziuni",
    desc: "Limitarea este dată de durere, leziuni deschise, cicatrici contractile (arsuri, dermatoze severe).",
    focus: [
      "Alimentația și Îmbrăcarea (ADL): Mișcarea e oprită de bride cicatriciale? Bulele provoacă dureri insuportabile și sângerări la îmbrăcare?",
      "Igienă și Toaletă (ADL/Barthel): Necesită ajutor la igienă din cauza incapacității de a plia degetele (cicatrici/amputații)?",
      "Mersul (Barthel): Poate purta încălțăminte? (ex. ulcere diabetice sau psoriazis palmoplantar grav fac imposibilă încălțarea)"
    ],
    color: "#fff0f5", borderColor: "#f9b6ce", icon: "🔥"
  }
};

export default function BarthelEvaluation({ formData, setFormData, boalaId, evalGroup }) {
  const [logicError, setLogicError] = useState(null);
  const barthelScores = formData[boalaId]?.barthel || {};
  const adlScores = formData[boalaId]?.adl || {};
  const iadlScores = formData[boalaId]?.iadl || {};

  const updateScores = (scaleKey, itemId, value) => {
    
    // --- MEDICAL LOGIC CONFLICT PREVENTION (Romanian Legislation) ---
    // If the patient is marked as Immobile/Bedridden (mobilitate = 0 OR transfer = 0)
    // Conform criteriilor de acordare a asistentului, imobilizarea la pat implică pierderea capacității de autoservire.
    const isCurrentlyImmobile = (barthelScores.mobilitate === 0) || (barthelScores.transfer === 0);
    
    // Items that strictly contradict "Imobile" if scored > 0
    const mobilityRequiredItems = {
      barthel: ['deplasare_scari'],
      adl: ['adl_transfer']
    };

    // Any other items (hygiene, feeding, dressing, iadl) strictly contradict "Imobile / Bedridden" 
    // if scored as fully "Independent" (max score).
    
    // 1. User is immobile, but tries to check ANY mobile/independent item
    if (isCurrentlyImmobile) {
      // Find the item definition to know its max score (which implies independence)
      const listToCheck = scaleKey === 'barthel' ? BARTHEL_ITEMS : (scaleKey === 'adl' ? ADL_ITEMS : IADL_ITEMS);
      const itemDef = listToCheck.find(i => i.id === itemId);
      
      if (itemDef) {
        const maxScore = itemDef.options[itemDef.options.length - 1].value;
        const strictMove = (scaleKey === 'barthel' && mobilityRequiredItems.barthel.includes(itemId) && value > 0) ||
                           (scaleKey === 'adl' && mobilityRequiredItems.adl.includes(itemId) && value > 0);
        const tryingIndependence = (value === maxScore && maxScore > 0); // They try to mark "Independent" on anything
        
        if (strictMove || tryingIndependence) {
           setLogicError("Incompatibilitate cu legislația curentă:\nPacientul a fost evaluat ca fiind 'Imobil' / 'Incapabil de transfer', ceea ce corespunde juridic cu pierderea totală a capacității de autoservire și o dependență totală.\n\nNu puteți bifa independență pentru această activitate (sau necesitatea de efort fizic la scări/transfer) fără a schimba întâi starea de la cap. 'Mobilitate / Transfer'.");
           return;
        }
      }
    }

    // 2. User tries to check "Imobil" but already has ANY independent/mobile items checked
    if (scaleKey === 'barthel' && (itemId === 'mobilitate' || itemId === 'transfer') && value === 0) {
      // Check if there are any > 0 scores in strictly physical items
      const hasStrictMoves = (barthelScores.deplasare_scari > 0) || (adlScores.adl_transfer > 0);
      
      // Check if there's ANY "Independent" score anywhere (meaning max value for that item) 
      // excluding incontinence issues (bladder/bowel are independent of physical mobility)
      const hasAnyIndependent = [...BARTHEL_ITEMS, ...ADL_ITEMS, ...IADL_ITEMS].some(item => {
        const itemScale = BARTHEL_ITEMS.includes(item) ? 'barthel' : (ADL_ITEMS.includes(item) ? 'adl' : 'iadl');
        const scoresObj = itemScale === 'barthel' ? barthelScores : (itemScale === 'adl' ? adlScores : iadlScores);
        const maxVal = item.options[item.options.length - 1].value;
        
        // Excepții pentru care Imobil nu dictează imposibilitatea de a fi "independent" în puncte (ex. continența sfincteriană poate fi completă și la paraplegici)
        const exceptions = ['tranzit_intestinal', 'vezica_urinara', 'adl_continenta']; 
        
        return !exceptions.includes(item.id) && scoresObj[item.id] === maxVal && maxVal > 0;
      });

      // Also check if trying to set mobilitate=0 while transfer>0, or transfer=0 while mobilitate>0
      const crossConflict = (itemId === 'mobilitate' && barthelScores.transfer > 0) ||
                            (itemId === 'transfer' && barthelScores.mobilitate > 0);

      if (hasStrictMoves || hasAnyIndependent || crossConflict) {
        setLogicError("Incompatibilitate cu legislația curentă:\nExistă deja opțiuni bifate care indică 'Independență' (ex: îmbrăcare sigură, mâncat, transfer etc.). Un pacient evaluat ca 'Imobil' presupune dependență totală administrativă.\n\nModificați acele opțiuni la o treaptă de 'Dependență' pentru a fi viabilă starea finală de 'Imobil / Incapabil de transfer'.");
        return;
      }
    }
    // --- END CONFLICT PREVENTION ---

    setLogicError(null);

    setFormData(prev => ({
      ...prev,
      [boalaId]: {
        ...prev[boalaId],
        [scaleKey]: {
          ...(prev[boalaId]?.[scaleKey] || {}),
          [itemId]: value
        }
      }
    }));
  };

  const barthelMax = BARTHEL_ITEMS.reduce((sum, item) => sum + item.options[item.options.length - 1].value, 0);
  const adlMax = ADL_ITEMS.reduce((sum, item) => sum + item.options[item.options.length - 1].value, 0);
  const iadlMax = IADL_ITEMS.reduce((sum, item) => sum + item.options[item.options.length - 1].value, 0);

  const barthelTotal = Object.values(barthelScores).reduce((a, b) => a + b, 0);
  const adlTotal = Object.values(adlScores).reduce((a, b) => a + b, 0);
  const iadlTotal = Object.values(iadlScores).reduce((a, b) => a + b, 0);

  const guide = EVAL_GROUPS[evalGroup] || EVAL_GROUPS[1];

  return (
    <div style={{ 
      marginBottom: '20px', 
      padding: '20px', 
      background: 'linear-gradient(135deg, #fff8e1, #fff3cd)', 
      borderRadius: '12px', 
      border: '1px solid #ffe082' 
    }}>
      <h4 style={{ color: '#f57f17', marginTop: 0, marginBottom: '4px', fontSize: '16px' }}>
        🧑‍🦽 Evaluarea Autonomiei – Barthel / ADL / IADL
        <InfoTooltip 
          title="Evaluarea Autonomiei – Barthel / ADL / IADL" 
          text={`Aceste scale evaluează capacitatea persoanei de a se îngriji singură.\n\n📊 INDEXUL BARTHEL (0-20 puncte):\n• 20 = Independent\n• 15-19 = Dependență ușoară\n• 10-14 = Dependență moderată\n• 5-9 = Dependență severă\n• 0-4 = Dependență totală\n\n🔵 ADL (Activities of Daily Living):\nEvaluează activitățile de bază: igienă, îmbrăcare, toaletă, transfer, continență, alimentare.\n\n🟣 IADL (Instrumental ADL):\nEvaluează activitățile instrumentale: telefon, cumpărături, gătit, menaj, rufe, transport, medicamente, finanțe.\n\n⚠️ IMPORTANT:\n• Funcție de grupul din care face parte boala, mecanismul de dependență diferă (ex: mecanic, cognitiv, hipoxie).\n• Un scor Barthel ≤ 5 duce direct la Handicap Grav cu Asistent Personal.\n• Completați pe baza observațiilor reale.`} 
        />
      </h4>
      <p style={{ fontSize: '13px', color: '#5d4037', margin: '0 0 16px 0' }}>
        Completați datele pentru a stabili exact gradul de dependență.
      </p>

      {/* Dynamic Context Guide */}
      <div style={{ 
        marginBottom: '24px', 
        padding: '14px 18px', 
        background: guide.color, 
        border: `1px solid ${guide.borderColor}`,
        borderRadius: '8px'
      }}>
        <h5 style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#333', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>{guide.icon}</span> {guide.title}
        </h5>
        <div style={{ fontSize: '12.5px', color: '#555', marginBottom: '10px' }}>
          <strong>Mecanism:</strong> {guide.desc}
        </div>
        <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '12px', color: '#444' }}>
          {guide.focus.map((line, i) => (
            <li key={i} style={{ marginBottom: '4px' }}>{line}</li>
          ))}
        </ul>
        <div style={{ marginTop: '10px', fontSize: '12px', fontWeight: 600, color: '#d32f2f' }}>
          ❗️ Notă: Dacă scorul Barthel scade spre 0-4 pct (sau ADL 0-3 pct), pacientul are dependență totală de altă persoană și necesită "Handicap Grav cu asistent personal".
        </div>
      </div>

      {/* Logic Error Modal Overlay */}
      {logicError && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 99999,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          backdropFilter: 'blur(3px)'
        }}>
          <div style={{
            background: 'white', padding: '24px 32px', borderRadius: '14px',
            maxWidth: '450px', width: '90%', boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
            border: '2px solid #ef5350'
          }}>
            <h3 style={{ margin: '0 0 16px 0', color: '#c62828', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '18px' }}>
              <span style={{ fontSize: '24px' }}>⚠️</span> Acțiune Blocată
            </h3>
            <p style={{ fontSize: '14px', color: '#333', lineHeight: '1.6', whiteSpace: 'pre-line', margin: '0 0 24px 0' }}>
              {logicError}
            </p>
            <div style={{ textAlign: 'right' }}>
              <button 
                onClick={() => setLogicError(null)}
                style={{
                  background: '#c62828', color: 'white', border: 'none',
                  padding: '10px 20px', borderRadius: '8px', fontWeight: 600, cursor: 'pointer',
                  fontSize: '14px', transition: 'background 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.background = '#b71c1c'}
                onMouseOut={(e) => e.target.style.background = '#c62828'}
              >
                Am înțeles, revin!
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Summary Bar */}
      <div style={{ 
        display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap'
      }}>
        <div style={{ flex: 1, minWidth: '180px', padding: '12px 16px', background: 'white', borderRadius: '10px', border: '1px solid #e0e0e0', textAlign: 'center' }}>
          <div style={{ fontSize: '12px', color: '#888', marginBottom: '4px' }}>Barthel</div>
          <div style={{ fontSize: '22px', fontWeight: 700, color: getBarhelInterpretation(barthelTotal).color }}>
            {barthelTotal}/{barthelMax}
          </div>
          <div style={{ fontSize: '11px', color: getBarhelInterpretation(barthelTotal).color, fontWeight: 600 }}>
            {getBarhelInterpretation(barthelTotal).text}
          </div>
        </div>
        <div style={{ flex: 1, minWidth: '180px', padding: '12px 16px', background: 'white', borderRadius: '10px', border: '1px solid #e0e0e0', textAlign: 'center' }}>
          <div style={{ fontSize: '12px', color: '#888', marginBottom: '4px' }}>ADL</div>
          <div style={{ fontSize: '22px', fontWeight: 700, color: getADLInterpretation(adlTotal, adlMax).color }}>
            {adlTotal}/{adlMax}
          </div>
          <div style={{ fontSize: '11px', color: getADLInterpretation(adlTotal, adlMax).color, fontWeight: 600 }}>
            {getADLInterpretation(adlTotal, adlMax).text}
          </div>
        </div>
        <div style={{ flex: 1, minWidth: '180px', padding: '12px 16px', background: 'white', borderRadius: '10px', border: '1px solid #e0e0e0', textAlign: 'center' }}>
          <div style={{ fontSize: '12px', color: '#888', marginBottom: '4px' }}>IADL</div>
          <div style={{ fontSize: '22px', fontWeight: 700, color: getADLInterpretation(iadlTotal, iadlMax).color }}>
            {iadlTotal}/{iadlMax}
          </div>
          <div style={{ fontSize: '11px', color: getADLInterpretation(iadlTotal, iadlMax).color, fontWeight: 600 }}>
            {getADLInterpretation(iadlTotal, iadlMax).text}
          </div>
        </div>
      </div>

      {/* Barthel */}
      <ScaleSection 
        title="Indexul Barthel (Activități cotidiene)"
        icon="📋"
        items={BARTHEL_ITEMS}
        scores={barthelScores}
        onScoreChange={(id, val) => updateScores('barthel', id, val)}
        interpretation={getBarhelInterpretation}
        maxScore={barthelMax}
      />

      {/* ADL */}
      <ScaleSection 
        title="ADL – Activități de Bază ale Vieții Zilnice"
        icon="🏥"
        items={ADL_ITEMS}
        scores={adlScores}
        onScoreChange={(id, val) => updateScores('adl', id, val)}
        interpretation={(score) => getADLInterpretation(score, adlMax)}
        maxScore={adlMax}
      />

      {/* IADL */}
      <ScaleSection 
        title="IADL – Activități Instrumentale ale Vieții Zilnice"
        icon="🔧"
        items={IADL_ITEMS}
        scores={iadlScores}
        onScoreChange={(id, val) => updateScores('iadl', id, val)}
        interpretation={(score) => getADLInterpretation(score, iadlMax)}
        maxScore={iadlMax}
      />
    </div>
  );
}
